import React from 'react';
import { BeatLoader } from 'react-spinners';
import { Route, Link, Switch, withRouter } from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import ReportTable from './reportTable';
import ReportCard from './reportCard';
import { getModuleEnum, getAccessLevelByModule, getSalesTaxStatus } from "../../../../server/util";

let allReports = [
  'Account Balance', 'Low balance', 'Purchase', 'Sales',
  'Sales Tax Report', 'Income by Grade', 'Daily Revenue', 'Monthly Revenue', 'Monthly Income',
  'Deposit', 'Adjustments', 'Deposit Summary', 'Event Payments',
  'BCAC Payments', 'Donations', 'Donation Match Report', 'Monthly Income Cash',
  'Bulk Purchases', 'Stripe Reconciliation report', 'Item Sales Summary', 'Consumption & payments Report'];

const modEnum = getModuleEnum();

class FinanicalReport extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
  }
  render() {
    const { location } = this.props;
    const stripeReport = location.state ? location.state.stripeReport : null;
    allReports = allReports.slice().sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
    let donationStatus = sessionStorage.getItem('donationStatus');
    let loggedInUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
    const isReportTableVisible = location.pathname === '/schoolAdmin/financialReport';
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <section className=" full-width clearfix">
          <div className='sweet-loading'
            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
            <BeatLoader
              size={20}
              color={'#ea7066'}
              loading={this.state.loading}
            />
          </div>
          {isReportTableVisible ?
            <div className="container p-5">
              <div class="row">
                <div className="sectionTitle">
                  <h2 style={{ marginLeft: '15px', marginTop: '3%' }}>
                    <span>Financial Reports</span>
                  </h2>
                </div>
              </div>
              <div className="row">
                {allReports.map(reportName => {
                  const _reportName = reportName.replaceAll('&', '_').replaceAll(' ', '')
                  return (
                    <Link key={reportName} to={{
                      pathname: '/schoolAdmin/financialReport/' + _reportName,
                      state: { stripeReport: stripeReport }
                    }}>
                      {reportName === 'Event Payments' && getAccessLevelByModule(modEnum.MPAE) ? (<div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}>
                        <ReportCard reportName={reportName} /></div>
                      ) : reportName === 'BCAC Payments' && getAccessLevelByModule(modEnum.BACP) ? (
                        <div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}><ReportCard reportName={reportName} reportNamePerm={_reportName} /></div>
                      ) : reportName === 'Sales Tax Report' && getSalesTaxStatus() ? (
                        <div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}><ReportCard reportName={reportName} reportNamePerm={_reportName} /></div>
                      ) : reportName === 'Donations' && donationStatus === 'true' ? (
                        <div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}><ReportCard reportName={reportName} reportNamePerm={_reportName} /></div>
                      ) : reportName === 'Bulk Purchases' && getAccessLevelByModule(modEnum.CEPS) ? (
                        <div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}><ReportCard reportName={reportName} reportNamePerm={_reportName} /></div>
                      ) : reportName === 'Stripe Reconciliation report' && loggedInUserInfo.stripeAccountId && loggedInUserInfo.isPaymentEnable ? (
                        <div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}><ReportCard reportName={reportName} reportNamePerm={_reportName} /></div>
                      ) : reportName !== 'Event Payments' && reportName !== 'BCAC Payments' && reportName !== 'Donations' && reportName !== 'Sales Tax Report' && reportName !== 'Bulk Purchases' && reportName !== 'Stripe Reconciliation report' ? (
                        <div className="col col-3 col-md-3" style={{ marginBottom: '5px' }}><ReportCard reportName={reportName} reportNamePerm={_reportName} /></div>
                      ) : ''}
                    </Link>
                  );
                }
                )}
              </div>
            </div> : null}

          {isReportTableVisible ? null :
            <Switch>
              <Route path="/schoolAdmin/financialReport/:reportName" component={ReportTable} />
            </Switch>
          }
        </section>
      </div>
    );
  }
}

export default withRouter(FinanicalReport);


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/index.jsx